document.addEventListener("DOMContentLoaded", function () {
  const originalButton = document.querySelector(
    '#AddToCart, button[name="add"].single-add-to-cart-button'
  );

  if (!originalButton) return;

  const mobileQuery = window.matchMedia("(max-width: 767px)");
  const stickyBar = document.createElement("div");
  const stickyButton = document.createElement("button");

  let busy = false;
  let feedbackTimer;

  stickyBar.className = "mobile-sticky-atc";
  stickyBar.setAttribute("aria-hidden", "true");

  stickyButton.type = "button";
  stickyButton.className = "mobile-sticky-atc__button";

  stickyBar.appendChild(stickyButton);
  document.body.appendChild(stickyBar);

  function syncButton() {
    if (busy) return;

    stickyButton.textContent =
      originalButton.textContent.trim() || "ADD TO CART";

    stickyButton.disabled = originalButton.disabled;
  }

  function updateVisibility() {
    if (!mobileQuery.matches) {
      stickyBar.classList.remove("is-visible");
      stickyBar.setAttribute("aria-hidden", "true");
      return;
    }

    const shouldShow =
      originalButton.getBoundingClientRect().top > window.innerHeight - 8;

    stickyBar.classList.toggle("is-visible", shouldShow);
    stickyBar.setAttribute("aria-hidden", String(!shouldShow));
  }

  async function getCartCount() {
    try {
      const root =
        window.Shopify?.routes?.root || "/";

      const response = await fetch(root + "cart.js", {
        credentials: "same-origin",
        cache: "no-store"
      });

      const cart = await response.json();
      return cart.item_count;
    } catch (error) {
      return null;
    }
  }

  function delay(milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  async function waitForCartChange(previousCount) {
    const timeoutAt = Date.now() + 10000;

    while (Date.now() < timeoutAt) {
      await delay(250);

      const currentCount = await getCartCount();

      if (
        previousCount !== null &&
        currentCount !== null &&
        currentCount !== previousCount
      ) {
        return true;
      }
    }

    return false;
  }

  function restoreButton() {
    busy = false;

    stickyButton.classList.remove("is-loading");
    stickyButton.removeAttribute("aria-busy");

    syncButton();
  }

  stickyButton.addEventListener("click", async function () {
    if (busy || originalButton.disabled) return;

    window.clearTimeout(feedbackTimer);

    busy = true;
    stickyButton.disabled = true;
    stickyButton.classList.add("is-loading");
    stickyButton.setAttribute("aria-busy", "true");
    stickyButton.textContent = "Adding…";

    const previousCount = await getCartCount();

    /*
     * Retains Kaching's existing bundle add process.
     */
    originalButton.click();

    const cartChanged = await waitForCartChange(previousCount);

    if (cartChanged) {
      stickyButton.textContent = "Added ✓";

      /*
       * Open AMP when its storefront API is available.
       * Remove this block if you only want button feedback.
       */
      try {
        if (
          window.AMP_API &&
          typeof window.AMP_API.OPEN_CART === "function"
        ) {
          window.AMP_API.OPEN_CART();
        }
      } catch (error) {
        // The product has still been added successfully.
      }

      feedbackTimer = window.setTimeout(restoreButton, 1200);
    } else {
      stickyButton.textContent = "Please try again";

      feedbackTimer = window.setTimeout(restoreButton, 1800);
    }
  });

  window.addEventListener("scroll", updateVisibility, {
    passive: true
  });

  window.addEventListener("resize", updateVisibility);

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener("change", updateVisibility);
  }

  new MutationObserver(function () {
    syncButton();
    updateVisibility();
  }).observe(originalButton, {
    attributes: true,
    childList: true,
    subtree: true
  });

  syncButton();
  updateVisibility();
});